// import * as _moment from 'moment';
import type { Moment } from 'moment';
// const moment = _moment;
import moment from 'moment';
// import 'moment-timezone';

// WHY: Pulled out the DateService functions so we can use it in Reducer files without initiating the service in a constructor.

export function getFirstOfNextMonth(dateOverride: Moment = moment()): Moment {
    const today = moment.parseZone(dateOverride);
    const nextMonth = today.add(1, 'M');
    const startOfNextMonth = nextMonth.startOf('M');
    return startOfNextMonth;
}

export function getNow() {
    return window.sessionStorage.getItem('dateOffset') ? moment(window.sessionStorage.getItem('dateOffset')) : moment();
}
